export default __webpack_public_path__ + "static/media/blue_bg_mobile.cf3f7932.jpg";